import type { Options } from './Shared'
import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Button, CheckboxField, CheckboxState } from '@sunwebgroup/ui-components/uds'
import { equals, reject } from 'ramda'
import * as React from 'react'
import { styled } from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  width: 100%;
  padding: ${space('primitives_space_16')};
`
export const CloseButton = styled(Button)`
  width: 100%;
`
export const Footer = styled.div`
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  background-color: ${tok('semantics_views_background_color')};
  z-index: 1;
  padding: ${space('primitives_space_12')} ${space('primitives_space_16')};
  border-top: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_dividers_color')};
`

interface FilterProps {
  options: Options[]
  selectedValues: string[]
  onSelectedValueChange: (newSelectedValue: string[]) => void
}

export function Root({ options, selectedValues, onSelectedValueChange }: FilterProps) {
  function handleCheckedChange(checked: CheckboxState, value: string) {
    if (checked) {
      onSelectedValueChange([...selectedValues, String(value)])
    }

    if (!checked) {
      onSelectedValueChange(reject(equals(value), selectedValues))
    }
  }

  return (
    <Content>
      {options.map((option, index) => (
        <CheckboxField
          key={index}
          label={option.name}
          name={option.name}
          value={option.value}
          onCheckedChange={checked => handleCheckedChange(checked, option.value)}
          defaultChecked={selectedValues.includes(option.value)}
        />
      ))}
    </Content>
  )
}
